import { capitalize } from "@mui/material";
import { Statusable } from "models/BO/BoUser";


export enum AiSimulationModel {
  GPT_41_nano = 'openai:gpt-4.1-nano',
  GPT_4_O = 'openai:gpt-4o',
  GPT_4_O_MINI = 'openai:gpt-4o-mini',
  GPT_3_5_TURBO = 'openai:gpt-3.5-turbo',
  
}

export enum AiSimulationMessageRole {
  USER = 'user',
  ASSISTANT = 'assistant',
}

export type AiSimulationMessage = {
  role: AiSimulationMessageRole;
  content: string;
}

export class AISimulation {
  id: string;


  profileId: string;



  model: AiSimulationModel;

  executedAt: Date;

  messages: string[];

  history: {[date: number]: AiSimulationMessage[]}

  description: string;

  insights: any[];

}
